// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mw-c";
export var backButton = "_mw-4";
export var backIcon = "_mw-5";
export var chevronShortcut = "_mw-6";
export var container = "_mw-1";
export var editor = "_mw-8";
export var editorWrapper = "_mw-7";
export var prefix = "_mw-2";
export var searchIcon = "_mw-3";
export var suffix = "_mw-9";
export var suffixContent = "_mw-a";
export var suffixText = "_mw-b";
export var wrapper = "_mw-0";